import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import Ticket from '@core/models/tickets/Ticket';
import TaxServiceSingleton, { TaxService } from '@core/services/betSlip/TaxService';
import ILottoBetSlipDTO from '@core/models/lottoBetSlip/ILottoBetSlipDto';
import LottoTicketEventMapper from './LottoTicketEventMapper';
import { Payout } from '@core/models/betSlip/Payout';

const lottoBetSlipTicketEventMapper = new LottoTicketEventMapper();

/* used to map the betslip into a ticket used for preview */

export default class LottoBetSlipToTicketMapper extends AbstractMapper<ILottoBetSlipDTO, Partial<Ticket>> {

    private taxService: TaxService;

    // TODO: Dino should check this
    createTargetObject(betSlip: any, predefinedData: Partial<Ticket> = {}) {
        this.taxService = TaxServiceSingleton.getInstance();
        const e = {
            ...predefinedData,
        } as Partial<Ticket>;
        e.payment = this.createPayment(betSlip);
        e.win = this.createWin(betSlip.payout);
        e.events = betSlip.selections.map((selection: number) => this.createEvent(betSlip, selection));
        return e;
    }

    private createPayment = (betSlip: any) => ({
        stake: betSlip.stakeAfterTax,
        handlingFee: betSlip.stake - betSlip.stakeAfterTax,
        branchId: '',
        total: betSlip.stake,
        tax: this.taxService.getStakeTaxByPurchaseType(betSlip.purchaseType),
    });

    private createWin = (payout: Payout) => ({
        branchId: '',
        minPotential: payout.minFinal,
        estimated: payout.base,
        payoff: payout.final,
        tax: payout.tax,
    });

    private createEvent = (betSlip: any, selection: number) =>
        lottoBetSlipTicketEventMapper.createTargetObject(
            { ...betSlip,
                selection
            }
        );

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/LottoBetSlipToTicketMapper.ts